import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import feesService from "../../services/fees.service";

// ================= Fee Category =================

export const getfeetype = createAsyncThunk(
  "fees/getfeetype",
  async (_, thunkAPI) => {
    try {
      const response = await feesService.getfeestype();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addfeetype = createAsyncThunk(
  "fees/addfeetype",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.addfeestype(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatefeetype = createAsyncThunk(
  "fees/updatefeetype",
  async (payload, thunkAPI) => {
    try {
      const response = await feesService.editfeestype(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// ================= Standard Fees =================

export const getstandardfees = createAsyncThunk(
  "fees/getstandardfees",
  async (item, thunkAPI) => {
    try {
      const response = await feesService.getStandardfees(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addstandardfees = createAsyncThunk(
  "fees/addstandardfees",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.addStandardfees(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatestandardfees = createAsyncThunk(
  "fees/updatestandardfees",
  async (payload, thunkAPI) => {
    try {
      const response = await feesService.editStandardfees(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addFeeCollection = createAsyncThunk(
  "fees/addFeeCollection",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.addFeeCollection(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getFeeCollection = createAsyncThunk(
  "fees/getFeeCollection",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.getFeesCollection(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const getDemandReport = createAsyncThunk(
  "fees/getDemandReport",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.getDemandReport(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const getDueReport = createAsyncThunk(
  "fees/getDueReport",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.getDueReport(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getDiscountReport = createAsyncThunk(
  "fees/getDiscountReport",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.getDiscountReport(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const addTransportFeeCollection = createAsyncThunk(
  "fees/addTransportFeeCollection",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.addTransportFeeCollection(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getstudentFeesDetails = createAsyncThunk(
  "fees/getstudentFeesDetails",
  async (item, thunkAPI) => {
    try {
      const response = await feesService.getstudentFeesDetails(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getRoute = createAsyncThunk(
  "fees/getRoute",
  async (item, thunkAPI) => {
    try {
      const response = await feesService.getRoute(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addRoute = createAsyncThunk(
  "fees/addRoute",
  async (data, thunkAPI) => {
    try {
      const response = await feesService.addRoute(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editRoute = createAsyncThunk(
  "fees/editRoute",
  async (payload, thunkAPI) => {
    try {
      const response = await feesService.editRoute(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const gettransportReport = createAsyncThunk(
  "fees/gettransportReport",
  async (item, thunkAPI) => {
    try {
      const response = await feesService.gettransportReport(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


const initialState = {
  loading: false,
  error: null,
  feestype: [],
  feeslist: [],
  studentFeeDetails: [],
  routes: [],
  collectionReport: [],
  demandReport: [],
  dueReport: [],
  discountReport: [],
  transportReport: []
};
const feesSlice = createSlice({
  name: "fees",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ================= Fee Category =================

      .addCase(getfeetype.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getfeetype.fulfilled, (state, action) => {
        state.loading = false;
        state.feestype = action.payload?.data || [];
      })
      .addCase(getfeetype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addfeetype.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addfeetype.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addfeetype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatefeetype.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatefeetype.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatefeetype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getRoute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.routes = action.payload?.data || [];
      })
      .addCase(getRoute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addRoute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRoute.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addRoute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(editRoute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editRoute.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editRoute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Standard Fees =================

      .addCase(getstandardfees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getstandardfees.fulfilled, (state, action) => {
        state.loading = false;
        state.feeslist = action.payload?.data || [];
      })
      .addCase(getstandardfees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addstandardfees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addstandardfees.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addstandardfees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatestandardfees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatestandardfees.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatestandardfees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // ================= Fee Collection =================

      .addCase(addFeeCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addFeeCollection.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addFeeCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(getFeeCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFeeCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.collectionReport = action.payload?.data || [];
      })
      .addCase(getFeeCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getDemandReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDemandReport.fulfilled, (state, action) => {
        state.loading = false;
        state.demandReport = action.payload?.data || [];
      })
      .addCase(getDemandReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getDueReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDueReport.fulfilled, (state, action) => {
        state.loading = false;
        state.dueReport = action.payload?.data || [];
      })
      .addCase(getDueReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(getDiscountReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDiscountReport.fulfilled, (state, action) => {
        state.loading = false;
        state.discountReport = action.payload?.data || [];
      })
      .addCase(getDiscountReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(gettransportReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gettransportReport.fulfilled, (state, action) => {
        state.loading = false;
        state.transportReport = action.payload?.data || [];
      })
      .addCase(gettransportReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(addTransportFeeCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTransportFeeCollection.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addTransportFeeCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Student Fee Details =================

      .addCase(getstudentFeesDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getstudentFeesDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.studentFeeDetails = action.payload?.data || null;
      })
      .addCase(getstudentFeesDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.studentFeeDetails = null;
      });
  },
});

export default feesSlice.reducer;